import {
  faArrowRight,
  faBolt,
  faCheckCircle,
  faCode,
  faLightbulb,
  faSeedling,
  faShieldAlt,
  faTools,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import homeHero from "../Assets/heroes/home-hero.webp";

const simpleValues = [
  {
    icon: faLightbulb,
    title: "Simplicity",
    copy: "We remove extra steps so people can get work done without friction.",
  },
  {
    icon: faBolt,
    title: "Impact",
    copy: "We focus on software that solves real problems for life and business.",
  },
  {
    icon: faCheckCircle,
    title: "Meaningful",
    copy: "Every feature has a purpose, a user, and a reason to exist.",
  },
  {
    icon: faTools,
    title: "Practical",
    copy: "We build tools that hold up in everyday conditions and real workflows.",
  },
  {
    icon: faShieldAlt,
    title: "Lean",
    copy: "We keep interfaces clear, fast, and easy to maintain.",
  },
  {
    icon: faSeedling,
    title: "Evolving",
    copy: "We improve with feedback and adapt as needs change.",
  },
];

function Home() {
  return (
    <div className="home-page">
      <section className="home-hero section-ms" aria-labelledby="home-title">
        <div className="section-ms-inner home-hero-inner">
          <div className="home-hero-copy">
            <p className="section-ms-kicker">MileSoft</p>
            <h1 id="home-title">Simple tools for life and business.</h1>
            <p className="home-hero-tagline">
              Simplifying Life Through Technology
            </p>
            <p className="home-hero-lede">
              MileSoft builds practical digital solutions that simplify life and
              business. We turn real needs into reliable web, mobile, and
              software products people can use with confidence.
            </p>
            <div className="home-hero-actions" aria-label="Primary actions">
              <Link to="/contacts" className="btn-ms btn-ms-primary btn-ms-lg">
                Start a conversation
                <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
              </Link>
              <Link
                to="/services"
                className="btn-ms btn-ms-secondary btn-ms-lg"
              >
                View services
              </Link>
            </div>
          </div>

          <div className="home-hero-aside">
            <figure className="hero-feature-media" aria-hidden="true">
              <img
                src={homeHero}
                alt=""
                width="1067"
                height="800"
                decoding="async"
              />
            </figure>

            <div className="home-hero-points" aria-label="MileSoft approach">
              <div className="home-point">
                <span className="brand-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={faCode} />
                </span>
                <div>
                  <h2>Practical software</h2>
                  <p>Web, mobile, and custom systems built around real tasks.</p>
                </div>
              </div>
              <div className="home-point">
                <span className="brand-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={faCheckCircle} />
                </span>
                <div>
                  <h2>Clear delivery</h2>
                  <p>Focused features, plain language, and reliable outcomes.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="section-ms section-ms-soft"
        aria-labelledby="simple-values-title"
      >
        <div className="section-ms-inner">
          <div className="home-section-heading">
            <p className="section-ms-kicker">S.I.M.P.L.E</p>
            <h2 id="simple-values-title">How we keep technology useful</h2>
            <p>
              Our work stays simple, practical, and reliable from the first
              idea to the finished product.
            </p>
          </div>
          <div className="home-value-grid">
            {simpleValues.map((value) => (
              <article className="card-ms home-value-card" key={value.title}>
                <div className="card-ms-body">
                  <span className="brand-icon" aria-hidden="true">
                    <FontAwesomeIcon icon={value.icon} />
                  </span>
                  <h3>{value.title}</h3>
                  <p>{value.copy}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section-ms" aria-labelledby="home-next-title">
        <div className="section-ms-inner home-next">
          <div>
            <p className="section-ms-kicker">Next step</p>
            <h2 id="home-next-title">Build something simple that works.</h2>
            <p>
              Tell us what you need to improve, automate, or launch. We will
              help shape it into a focused digital solution.
            </p>
          </div>
          <Link to="/contacts" className="btn-ms btn-ms-primary btn-ms-md">
            Contact MileSoft
            <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Home;
